import { Fragment, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router';
import { CreateAccount, Layout, ReportTypeEnum, ResetPassword } from 'fragments';
import { Home, OrderNow, Orders, NotFound, Terms, Privacy, ContactUs, Reports } from 'pages';
import { SaveParams } from 'utils';

export const Routers = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem('access-token');
  const link = window.location.search;
  const { pathname } = location;
  const info = location?.state;

  useEffect(() => {
    if (link.search('resetToken=') !== -1) {
      localStorage.removeItem('access-token');
      localStorage.removeItem('userInfo');
    }
  }, []);

  useEffect(() => {
    if (((pathname === '/' || (pathname === '/order-now')) && !info?.reportType)) {

      const params = {
        ...info,
        reportType: ReportTypeEnum.FRV,
      };

      SaveParams(pathname, navigate, params);
    }
  }, [pathname, info?.reportType]);


  const handleChangeFrvOrFmv = (value) => {
    const params = {
      ...info,
      reportType: value,
    };
    SaveParams(pathname, navigate, params);
  };

  return (
    <Fragment>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Home handleChangeFrvOrFmv={handleChangeFrvOrFmv} />} />
          <Route path='/order-now' element={<OrderNow />} />
          <Route path='/report/:id' element={<Reports />} />
          {!token &&
          <Route path='/resetPassword/:resetToken?' element={<ResetPassword />} />
          }
          {token
            && <Route path='/orders' element={<Orders />} />
          }
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/terms' element={<Terms />} />
          <Route path='/privacy' element={<Privacy />} />
          <Route path='/sign-up' element={<CreateAccount />} />
          <Route path='*' element={<NotFound />} />
        </Route>

      </Routes>
    </Fragment>
  );
};
